import React from 'react';
import { Phone } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contact">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3 className="footer-logo">Owleyes</h3>
            <p className="footer-tagline">
              Making digital transformation simple, practical, and profitable for growing businesses.
            </p>
          </div>
          
          <div className="footer-links">
            <div className="footer-col">
              <h4 className="footer-heading">Services</h4>
              <ul className="footer-list">
                <li><a href="#services">Everyday Digital Setup</a></li>
                <li><a href="#services">AI-Enabled Workflow Automation</a></li>
                <li><a href="#services">Business Transformation & AI Makeover</a></li>
                <li><a href="#services">Creative Strategy & Brand Visibility</a></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h4 className="footer-heading">Company</h4>
              <ul className="footer-list">
                <li><a href="#about">About</a></li>
                <li><a href="#approach">Approach</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="/privacy/">Privacy notice</a></li>
              </ul>
            </div>
            
            <div className="footer-col">
              <h4 className="footer-heading">Connect</h4>
              <ul className="footer-list">
                <li><a href="mailto:info@owl-eyes.in">info@owl-eyes.in</a></li>
                <li><a href="https://www.linkedin.com/company/owleyes/?viewAsMember=true" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                <li>
                  <a href="tel:+919717444240" className="footer-phone-link" aria-label="Call Owleyes at +91 97174 44240">
                    <Phone size={18} strokeWidth={1.8} aria-hidden="true" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Owleyes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
